import { type CSSProperties } from 'react';

const PERCENTAGE_MULTIPLIER = 100;

export type CommentRangeValue = { endTime: number; startTime: number };

export const getCommentRangePercentStyle = (
  { startTime, endTime }: CommentRangeValue,
  duration: number,
  minWidthPx?: number,
): CSSProperties => ({
  left: `${(Math.min(startTime, endTime) / duration) * PERCENTAGE_MULTIPLIER}%`,
  width: `${(Math.abs(endTime - startTime) / duration) * PERCENTAGE_MULTIPLIER}%`,
  ...(minWidthPx === undefined ? {} : { minWidth: `${minWidthPx}px` }),
});
